import React, { useEffect, useState, useRef } from "react";
import { Link } from "gatsby";
import "../styles/Navbar.css";
import logo from "../images/omega-logo.png";
import { useDetectOutsideClick } from "./Dropdown";
// responsive menu toggle icon
import { FiMenu } from "react-icons/fi";
import { FaCaretDown } from "react-icons/fa";
// Dropdown Icons
import corporativoIcon from "../images/corporativo-icon.svg";
import nosotrosIcon from "../images/nosotros.svg";
import turismoIcon from "../images/turismo-icon.svg";
import destinosIcon from "../images/destinos-icon.svg";
import promocionesIcon from "../images/promociones-icon.svg";
import infoIcon from "../images/info-icon.svg";
import contactIcon from "../images/contact-icon.svg";

const Navbar = ({ toggleSidebar }) => {
  //navbar scroll when active state
  const [navbar, setNavbar] = useState(false);

  //navbar scroll changeBackground function
  const changeBackground = () => {
    if (window.scrollY >= 75) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    changeBackground();
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground);
  });

  //navbar dropdown Compañia
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const onClick = () => setIsActive(!isActive);

  //navbar dropdown Viajes
  const dropdownRefViajes = useRef(null);
  const [isActiveViajes, setIsActiveViajes] = useDetectOutsideClick(
    dropdownRefViajes,
    false
  );
  const onClickViajes = () => setIsActiveViajes(!isActiveViajes);

  //navbar dropdown Soporte
  const dropdownRefSoporte = useRef(null);
  const [isActiveSoporte, setIsActiveSoporte] = useDetectOutsideClick(
    dropdownRefSoporte,
    false
  );
  const onClickSoporte = () => setIsActiveSoporte(!isActiveSoporte);

  return (
    <>
      <>
        <div className={navbar ? "navbar active" : "navbar"}>
          <div className="navbar-center">
            <div className="navbar-header">
              <Link to="/">
                <img src={logo} alt="Bridge logo" loading="eager" />
              </Link>
              <button
                type="button"
                className="toggle-btn"
                onClick={toggleSidebar}
                aria-label="Hamburger menu"
              >
                <FiMenu />
              </button>
            </div>
            <div>
              <ul className={" navbar-links dropdown-align "}>
                <li tabindex="0" className="dropdown-btn" onClick={onClick}>
                  Compañia <FaCaretDown className="arrowDown" />
                </li>
                <nav
                  ref={dropdownRef}
                  className={`menu  dropdown ${
                    isActive ? "active" : "inactive"
                    }`}
                >
                  <ul>
                    <div className="dropdown-columns-align">
                      <li>
                        <img
                          src={nosotrosIcon}
                          className="dropdown-icons"
                          alt="tasking icon"
                          loading="eager"
                        />
                        <Link to="/nosotros/" activeClassName="active-page">
                          Nosotros
                        </Link>
                      </li>
                    </div>
                    <div className="dropdown-columns-align">
                      <li>
                        <img
                          src={turismoIcon}
                          className="dropdown-icons-scheduling"
                          alt="bridge portal icon"
                          loading="eager"
                        />
                        <Link to="/turismo/" activeClassName="active-page">
                          Turismo
                        </Link>
                      </li>
                    </div>
                  </ul>
                </nav>
                <ul
                  tabindex="0"
                  className="dropdown-btn"
                  activeClassName="active-page"
                >
                  <li onClick={onClickViajes}>
                    Viajes <FaCaretDown className="arrowDown" />
                  </li>
                  <nav
                    ref={dropdownRefViajes}
                    className={`menu-viajes  dropdown ${
                      isActiveViajes ? "active" : "inactive"
                      }`}
                  >
                    <div className="dropdown-columns-align-viajes">
                      <li className="menu-viajes-links">
                        <img
                          src={destinosIcon}
                          className="dropdown-icons"
                          alt="tasking icon"
                          loading="eager"
                        />
                        <Link to="/destinos/" activeClassName="active-page">
                          Destinos
                        </Link>
                      </li>
                    </div>
                    <div className="dropdown-columns-align-viajes">
                      <li className="menu-viajes-links">
                        <img
                          src={promocionesIcon}
                          className="dropdown-icons"
                          alt="tasking icon"
                          loading="eager"
                        />
                        <Link to="/promociones/" activeClassName="active-page">
                          Promociones
                        </Link>
                      </li>
                    </div>
                    <div className="dropdown-columns-align-viajes">
                      <li className="menu-viajes-links">
                        <img
                          src={infoIcon}
                          className="dropdown-icons"
                          alt="tasking icon"
                          loading="eager"
                        />
                        <Link to="/info-viajes/" activeClassName="active-page">
                          Info Viajes
                        </Link>
                      </li>
                    </div>
                  </nav>
                </ul>
                <ul className="dropdown-align" activeClassName="active-page">
                  <li
                    tabindex="0"
                    className="dropdown-btn"
                    onClick={onClickSoporte}
                  >
                    Soporte <FaCaretDown className="arrowDown" />
                  </li>
                  <nav
                    ref={dropdownRefSoporte}
                    className={`menu-company  dropdown ${
                      isActiveSoporte ? "active" : "inactive"
                      }`}
                  >
                    <div className="dropdown-columns-align-company">
                      <li className="menu-company-links">
                        <img
                          src={contactIcon}
                          className="dropdown-icons"
                          alt="tasking icon"
                          loading="eager"
                        />
                        <Link to="/contactanos/" activeClassName="active-page">
                          Contactanos
                        </Link>
                      </li>
                    </div>
                  </nav>
                </ul>
                <Link
                  to="/contactanos/"
                  activeClassName="active-page"
                  className="btn-navbar"
                >
                  Contactanos
                </Link>
              </ul>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Navbar;
